import { Fragment, type ComponentPropsWithoutRef, type ReactNode } from "react";

import { cx } from "../../lib/cx";
import { Icon } from "../core/Icon";
import s from "./TopBar.module.css";

export interface TopBarProps extends Omit<ComponentPropsWithoutRef<"header">, "title"> {
  title?: string;
  subtitle?: string;
  /** Controles a la derecha. */
  actions?: ReactNode;
  /** Los ancestros, con chevrones entre medio. */
  breadcrumb?: string[];
}

/** La cabecera fija de cada pantalla del panel: migas, título, subtítulo y acciones. */
export function TopBar({ title, subtitle, actions, breadcrumb, className, ...rest }: TopBarProps) {
  return (
    <header className={cx(s.topbar, className)} {...rest}>
      <div className={s.textos}>
        {breadcrumb?.length ? (
          <nav aria-label="Migas" className={s.migas}>
            {breadcrumb.map((b, i) => (
              <Fragment key={i}>
                {i ? <Icon name="chevron-right" size={12} /> : null}
                <span>{b}</span>
              </Fragment>
            ))}
          </nav>
        ) : null}
        <h1 className={s.titulo}>{title}</h1>
        {subtitle ? <div className={s.subtitulo}>{subtitle}</div> : null}
      </div>
      {actions ? <div className={s.acciones}>{actions}</div> : null}
    </header>
  );
}
